import { PageHero } from "@/components/common/PageHero";
import { Reveal } from "@/components/common/Reveal";
import { SectionHeading } from "@/components/common/Primitives";
import { ServicesGrid, MaterialHandling, WhyAutomex, ContactBand } from "@/components/home/Sections";
import { useSeo } from "@/hooks/useSeo";
import { IMAGES, TECH_SERVICES } from "@/data/site";

export default function IndustrialTechnologies() {
  useSeo({
    title: "AutoMex Industrial Technologies | Machinery, Automation & Material Handling Pune",
    description: "AutoMex Industrial Technologies: industrial machinery, automation, material handling, EOT cranes, machine integration and industrial technology solutions in Pune.",
    path: "/industrial-technologies",
  });
  return (
    <>
      <PageHero
        overline="AutoMex Industrial Technologies"
        title="Technology That Moves Industry Forward."
        subtitle="Machinery, automation, material handling and industrial equipment — integrated with your infrastructure and production goals."
        image={IMAGES.tech}
        crumb="Industrial Technologies"
      />
      <section className="py-24 md:py-32 bg-white">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
          <Reveal className="mb-12 flex justify-center">
            <img src="/logos/automex-tech.png" alt="AutoMex Industrial Technologies" className="h-24 md:h-32 w-auto object-contain" />
          </Reveal>
          <Reveal>
            <SectionHeading
              overline="Capabilities"
              title="Machinery, Automation & Integration."
              subtitle="Practical industrial technology aligned to real plant and process needs — from machinery selection to commissioning support."
            />
          </Reveal>
          <div className="mt-14"><ServicesGrid services={TECH_SERVICES} columns={4} /></div>
        </div>
      </section>
      <MaterialHandling />
      <WhyAutomex />
      <ContactBand />
    </>
  );
}
